export const characters: Record<string, string> = {
	char_green_name: "Green",
	char_blue_name: "Blue",
	char_red_name: "Red",
	char_green_desc: "Solidifier: traps enemies in solid blocks",
	char_blue_desc: "Cryo Gun: shorter range, freezes the target and nearby enemies",
	char_red_desc: "Cleaver: melee, dashes at nearby enemies",
	char_blue_unlockHint: "Complete level 4",
	char_red_unlockHint: "Reach the caves",
};
